// extracted by mini-css-extract-plugin
module.exports = {"form_container":"Recover_form_container__3eA1v","login_page_container":"Recover_login_page_container__1bjgW","language":"Recover_language__1SPgg"};